import { render } from "./Brands.vue?vue&type=template&id=1f645bbf"
import script from "./Brands.vue?vue&type=script&lang=js"
export * from "./Brands.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/nasimdinari-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__